import { ENDPOINTS } from '@polyai/stream/endpoints';
import type {
  AgentSetupBody,
  AgentWizardConfigUpdateBody,
} from '@polyai/stream/handlers/agent-wizard/types';

import { doGet, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  AgentSetupActiveJobsResponse,
  AgentSetupStatusResponse,
} from './types';

export const agentWizardAgentSetup = ({
  accountId,
  projectId,
  body,
}: {
  accountId: string;
  projectId: string;
  body: AgentSetupBody;
}) => {
  return doPost<AgentSetupStatusResponse>(
    generateNextPath(ENDPOINTS.AGENT_SETUP, { accountId, projectId }),
    LOGGER_TYPE.PROJECT,
    body,
    {
      prefix: 'sourcerer',
    },
  );
};

export const agentWizardAgentSetupStatus = ({
  accountId,
  projectId,
}: {
  accountId: string;
  projectId: string;
}) => {
  return doGet<AgentSetupStatusResponse>(
    generateNextPath(ENDPOINTS.AGENT_SETUP_STATUS, { accountId, projectId }),
    LOGGER_TYPE.PROJECT,
    {
      prefix: 'sourcerer',
    },
  );
};

export const agentWizardActiveJobs = ({ accountId }: { accountId: string }) => {
  return doGet<AgentSetupActiveJobsResponse>(
    generateNextPath(ENDPOINTS.AGENT_SETUP_ACTIVE_JOBS, { accountId }),
    LOGGER_TYPE.ACCOUNT,
    {
      prefix: 'sourcerer',
    },
  );
};

export const agentWizardUpdateConfig = ({
  accountId,
  projectId,
  body,
}: {
  accountId: string;
  projectId: string;
  body: AgentWizardConfigUpdateBody;
}) => {
  return doPost<{
    success: boolean;
    message: string;
    sequenceId: string;
    branchId: string;
  }>(
    generateNextPath(ENDPOINTS.AGENT_CONFIG_UPDATE, { accountId, projectId }),
    LOGGER_TYPE.PROJECT,
    body,
    {
      prefix: 'sourcerer',
    },
  );
};
